module.exports = __webpack_public_path__ + "img/security.1a542578.png";